exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.container[data-v-5601328a]{padding:20px\n}\n.container .card[data-v-5601328a]{width:100%\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/central/cadastros/maranhao/liberacao/Cadastro.vue"],"names":[],"mappings":";AAsEA,4BACE,YAAa;CADf;AAAA,kCAGI,UAAW;CACZ","file":"Cadastro.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.container {\n  padding: 20px;\n  .card {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5601328a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/cadastros/maranhao/liberacao/Cadastro.vue
// module id = cppm
// module chunks = 11